module.exports = __webpack_public_path__ + "static/media/imgactivea.038253d1.png";